export default __webpack_public_path__ + "static/rowSelection-5e8645d57663d8244969a3f16045e283.gif";